import { Step as StepProps } from '@service-victoria/component-library/components/Wizard/props';

import * as Interfaces from 'app/interfaces';
import { TransactionType } from 'app/interfaces/common';
import { submitProviderEditRequest } from 'app/services/gakService';
import * as Steps from 'app/transactions/provider/steps';
import { constants, logger } from 'app/utils';
import React from 'react';
import { serializeForm } from './helpers';

const Component = React.lazy(() => import('./Review'));

const Step: StepProps<Interfaces.Common.ProviderFormValues> = {
  id: 'review',
  title: constants.ProviderDetailsPage.title,
  stepName: 'Review changes',
  Component,
  navigation: {
    normal: [
      {
        content: 'Back',
        type: 'secondary',
        shouldValidate: false,
        onClick: (wizardContext, form) => {
          wizardContext.dispatch({
            type: 'GOTO_STEP',
            stepId: Steps.ProviderDetails.Step.id,
            values: form.values
          });
        }
      },
      {
        content: 'Submit',
        shouldValidate: true,
        isSubmit: true,
        type: 'primary',
        onClick: async (context, form, appStates) => {
          const appContext = appStates[
            constants.ProviderStorageKeys.State
          ] as Interfaces.Store.AppContext;

          try {
            form.setSubmitting(true);
            form.submitCount += 1;

            if (!appContext.currentState.idToken?.rawToken)
              throw new Error('ID token not set, authorised contact cannot be identified.');

            if (!appContext.currentState.providerDetails?.id)
              throw new Error('No provider set, cannot identify what activity provider to update');

            const formData = form.values as Interfaces.Common.ProviderFormValues;
            const {
              transactions,
              idToken: { rawToken: idToken }
            } = appContext.currentState;

            const status = await submitProviderEditRequest(
              serializeForm(
                transactions[TransactionType.ProviderDetails].ID,
                appContext.currentState.providerDetails.id,
                idToken,
                formData
              )
            );

            if (status === 'SUCCESS') {
              form.submitForm();
            } else {
              throw new Error(`Invalid status returned from GAK service: ${status}`);
            }

            context.dispatch({
              type: 'GOTO_STEP',
              stepId: Steps.Done.Step.id,
              values: form.values
            });
          } catch (error: any) {
            logger.error('Transaction submission failed', error);
            context.dispatch({
              type: 'GOTO_STEP',
              stepId: Steps.Error.Step.id,
              values: form.values
            });
          }
          form.setSubmitting(false);
        }
      }
    ]
  }
};

export { Step };
